import React, { useEffect, useState, useRef, useImperativeHandle } from "react";
import { Modal, Panel, Text, SelectPicker } from "rsuite";
import {
  getStockInsumo,
  getInsumos,
  getInsumosSesion,
  addInsumoSesion,
  deleteInsumo,
} from "../Services/SesionHemoServices";
import { Input, Button, notification } from "antd";
import { Plus, Save, Trash } from "lucide-react";
import { FaBackward } from "react-icons/fa";
import Table from "react-bootstrap/Table";
import { soloNumeros } from "../../Utils";

export const ModalInsumos = ({ idNegocio, openInsumos, idUser, idSesion, paciente, ref }) => {
	const [isOpen, setIsOpen] = useState(false);
  const [idEntradaSesion, setIdEntradaSesion] = useState(null);
  const [stock, setStock] = useState(0);
  const [cantidad, setCantidad] = useState(0);
  const [dataInsumos, setDataInsumos] = useState([]);
  
  const [listInsumos, setListInsumos] = useState([]);

  const initialized = useRef(false);
  const [api, contextHolder] = notification.useNotification();

  const errorNotificaction = (title, msj) => {
    api.error({
      title: title,
      description: msj,
      duration: 5,
      styles: { root: { backgroundColor: "#FFE4E0" } },
      showProgress: true,
    });
  };

  const successNotification = (title, msj) => {
    api.success({
      title: title,
      description: msj,
      duration: 5,
      styles: { root: { backgroundColor: "#ECFFE0" } },
      showProgress: true,
    });
  };

  const eliminaRenglon = async (props) => {
    const data = {
      id: idNegocio,
      idSesion: idSesion,
      cantidad: props.cantidad,
      idInsumo: props.idInsumo,
      idEntrada: props.idEntrada,
    };
    await deleteInsumo(data)
      .then(async (res) => {
        await getInsumosSesion(idNegocio, idSesion).then(async (res) => {
          successNotification("Renglón", "Se ha eliminado el renglón...");
          setListInsumos(res);
        });
      })
      .catch((error) => {
        errorNotificaction(error.name, error.message);
      });
  };

  const loadInsumos = async () => {
    await getInsumos(idNegocio).then((res) => {
      setDataInsumos(res);
			
    });
  };

  const handleStock = async (e) => {
    if (e === null) {
      setIdEntradaSesion(null);
      setStock(0);
      return;
    }
    await getStockInsumo(idNegocio, 0, e)
      .then((res) => {
        setIdEntradaSesion(e);
        setStock(res);
      })
      .catch((err) => {
        errorNotificaction(err.name, err.message);
      });
  };

  const addInsumo = async () => {
    const data = {
      id: idNegocio,
      idSesion: idSesion,
      idInsumo: 0,
      idEntrada: idEntradaSesion,
      cantidad: cantidad,
      idUser: idUser,
    };
    await addInsumoSesion(data)
      .then(async (res) => {
        if (res.data > 0) {
          successNotification(
            "Insumo agregado",
            "Se agrego el insumo a la sesión del paciente.",
          );
          await getInsumosSesion(idNegocio, idSesion).then(async (res) => {
            setListInsumos(res);
            setIdEntradaSesion(null);
            setStock(0);
            setCantidad(0);
          });
        }
      })
      .catch((err) => {
        errorNotificaction(err.name, err.message);
      });
  };

  const handleClose = () => {
    setIdEntradaSesion(null);
    setCantidad(0);
    setStock(0);
    setIsOpen(false);
  };

  useEffect(() => {
    if (!initialized.current) {
      initialized.current = true;
      loadInsumos();
    }
  }, []);

	useImperativeHandle(
    ref,
    () => ({
      open: () => setIsOpen(true),
      close: () => setIsOpen(false),
      toggle: () => setIsOpen((_) => !_),
    }),
    []
  );

  return (
    <div>
      {contextHolder}
      <Modal
        backdrop={"static"}
        keyboard={true}
        size={"lg"}
        open={isOpen}
        onClose={handleClose}
      >
        <Modal.Header>
          <Modal.Title>
            Agregar insumos a la sesión No. {idSesion} / Paciente: {paciente}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Panel bordered>
            <div className="row mb-2">
              <div className="col-lg-7 col-md-7 col-sm-7">
                <Text>Insumo</Text>
                <SelectPicker
                  block
                  value={idEntradaSesion}
                  data={dataInsumos}
                  onChange={(e) => handleStock(e)}
                  placeholder="-- Selecciona --"
                />
              </div>
              <div className="text-center col-lg-2 col-md-2col-sm-2">
                <Text>Stock</Text>
                <Input readOnly value={stock} style={{ textAlign: "center" }} />
              </div>
              <div className="col-lg-2 col-md-2 col-sm-2">
                <Text>Cantidad</Text>
                <Input
                  value={cantidad}
                  style={{ textAlign: "center" }}
                  onFocus={(event) => event.target.select()}
                  onChange={(e) => setCantidad(soloNumeros(e))}
                  controls={false}
                />
              </div>
              <div className="text-end col-lg-1 col-md-1 col-sm-1">
                <br></br>
                <Button
                  type="primary"
                  block
                  disabled={
                    idEntradaSesion !== null && cantidad > 0 ? false : true
                  }
                  onClick={addInsumo}
                  icon={<Save size={16}></Save>}
                ></Button>
              </div>
            </div>
          </Panel>
          <br></br>
          <Panel bordered header="Detalle de Insumos">
            <div className="row">
              <div className="col">
                <Table
                  striped
                  bordered
                  hover
                  responsive
                  style={{ fontSize: "16px" }}
                >
                  <thead>
                    <tr>
                      <td style={{ textAlign: "center" }}>
                        <Text weight="semibold">#</Text>
                      </td>
                      <td>
                        <Text weight="semibold">
                          Insumo (Material o Medicamento)
                        </Text>
                      </td>
                      <td style={{ textAlign: "center" }}>
                        <Text weight="semibold">Cantidad</Text>
                      </td>
                      <td style={{ textAlign: "center" }}>
                        <Text weight="semibold">Acción</Text>
                      </td>
                    </tr>
                  </thead>
                  <tbody>
                    {listInsumos.length > 0
                      ? listInsumos.map((item, index) => {
                          return (
                            <tr>
                              <td style={{ textAlign: "center" }}>
                                {Number(index) + 1}
                              </td>
                              <td>{item.insumo}</td>
                              <td style={{ textAlign: "center" }}>
                                {item.cantidad}
                              </td>
                              <td style={{ textAlign: "center" }}>
                                <Button
                                  key={`btn-${index}`}
                                  style={{ color: "red" }}
                                  onClick={() =>
                                    eliminaRenglon({
                                      idInsumo: item.idInsumo,
                                      cantidad: item.cantidad,
                                      idEntrada: item.idEntrada,
                                    })
                                  }
                                  icon={<Trash size={16}></Trash>}
                                  size="sm"
                                />
                              </td>
                            </tr>
                          );
                        })
                      : ""}
                  </tbody>
                </Table>
              </div>
            </div>
          </Panel>
        </Modal.Body>
        <Modal.Footer>
          <Button
            onClick={handleClose}
            type="default"
            icon={<FaBackward></FaBackward>}
          >
            Regresar
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};
